import { AddFileRequest } from "./add-file-request";
import { File } from "./file";
export class LeaseSignature {
  leaseId: number;
  addendumId: number | null;
  newSignature: AddFileRequest;
  existingSignature?: File;
  hasPrintSignature: boolean;
}
